import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/Home'
import Enterprise from '@/view/Enterprise'
import Consulting from '@/view/Consulting'
import Information from '@/view/Information'
import Product from '@/view/Product'
import News from '@/view/News'
import creditColumn from '@/view/creditColumn'
import antiMoneyLaundering from '@/view/antiMoneyLaundering'
import consumerProtection from '@/view/consumerProtection'
import Forbid from '@/view/Forbid'
import Details from '../view/News/Details/index.vue'
import ProtocolContainer from '@/view/ProtocolContainer/index.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/enterprise',
      name: 'Enterprise',
      component: Enterprise,
    },
    {
      path: '/consulting',
      name: 'Consulting',
      component: Consulting,
    },
    {
      path: '/information',
      name: 'Information',
      component: Information,
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
    },
    {
      path: '/creditColumn',
      name: 'CreditColumn',
      component: creditColumn,
    },
    {
      path: '/antiMoneyLaundering',
      name: 'AntiMoneyLaundering',
      component: antiMoneyLaundering,
    },
    {
      path: '/consumerProtection',
      name: 'ConsumerProtection',
      component: consumerProtection,
    },
    {
      path: '/details/:id',
      name: 'Details',
      component: Details,
    },
    {
      path: '/forbid',
      name: 'Forbid',
      component: Forbid,
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: ProtocolContainer,
    },
  ]
})

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  // console.log('to---',to);
  // console.log('from---',from);
  if(to.name!==from.name){
    localStorage.setItem('url', JSON.stringify(to.name))
    next()
  }else{
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js